import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarImages = _resolveComponent("ToolbarImages")!
  const _component_MapComponentOL = _resolveComponent("MapComponentOL")!
  const _component_ImagesTable = _resolveComponent("ImagesTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.subheaderDisplay)
      ? (_openBlock(), _createBlock(_component_ToolbarImages, {
          key: 0,
          title: _ctx.pageTitle,
          onApplyfilter: _ctx.loadData,
          ref: "theToolbar"
        }, null, 8, ["title", "onApplyfilter"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_component_MapComponentOL, {
      mapid: "map1",
      ref: "theMap",
      key: 0,
      imageDict: _ctx.imageData,
      siteViewParameters: _ctx.siteViewParameters,
      onViewChanged: _ctx.setMapView,
      mapViewToSet: _ctx.mapView,
      maxLoadedImages: 15,
      imageIsLoading: _ctx.imageIsLoading,
      showButtons: true,
      showImage: _ctx.showImage,
      onPreviousRow: _ctx.previousRow,
      onNextRow: _ctx.nextRow
    }, null, 8, ["imageDict", "siteViewParameters", "onViewChanged", "mapViewToSet", "imageIsLoading", "showImage", "onPreviousRow", "onNextRow"])),
    _createVNode(_component_ImagesTable, {
      onClickROW: _ctx.clickROW,
      ref: "tableView"
    }, null, 8, ["onClickROW"])
  ], 64))
}